import { render, staticRenderFns } from "./ClientesController.vue?vue&type=template&id=89dc8794&"
import script from "./ClientesController.vue?vue&type=script&lang=js&"
export * from "./ClientesController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports